import type { AreaScope, CatCard, Comment, ModerationStatus } from "../types";

const highRiskTerms = [
  "交易",
  "出售",
  "收猫",
  "微信",
  "电话",
  "坐标",
  "门牌",
  "地址",
];

export const suggestedArea: AreaScope = {
  province: "浙江省",
  city: "杭州市",
  district: "西湖区",
  street: "文新街道",
};

export function moderateComment(
  text: string,
  hasImage: boolean,
): ModerationStatus {
  if (highRiskTerms.some((term) => text.includes(term)) || hasImage)
    return "pending";
  return "published";
}

export function createDemoCard(
  input: Pick<
    CatCard,
    "species" | "name" | "image" | "cutoutImage" | "cutoutStatus" | "area" | "game"
  >,
): CatCard {
  const suffix = String(Date.now()).slice(-6);
  const seed = Number(suffix);
  const isDog = input.species === "dog";
  return {
    id: `cat-${suffix}`,
    species: input.species,
    code: `${isDog ? "DOG" : "CAT"}-2026-${suffix}`,
    name: input.name || (isDog ? "未命名的小狗" : "未命名的小猫"),
    image: input.image,
    cutoutImage: input.cutoutImage,
    cutoutStatus: input.cutoutStatus,
    emoji: isDog ? "🐶" : "🐈",
    palette: isDog
      ? "linear-gradient(145deg, #d1a46c, #65442e)"
      : "linear-gradient(145deg, #e3b36d, #6d4834)",
    coat: isDog ? "浅棕与奶白" : "暖橘与奶白",
    feature: isDog ? "黑色鼻尖与竖起的耳朵" : "鼻尖有一小块浅色毛",
    observedAt: "今天",
    area: input.area,
    observation: "AI 视觉观察：它看起来正在安静地确认周围的声音。",
    game: {
      ...input.game,
      rarity: evaluateDemoRarity(seed),
    },
    likes: 0,
    boostCount: seed % 100,
    isMine: true,
  };
}

/**
 * 临时演示评定逻辑。正式版由服务端 AI/运营规则评定；UR 仅能由官方活动授予，
 * 因而普通记录流程永远不能生成 UR。
 */
export function evaluateDemoRarity(seed: number): "SSR" | "SR" | "R" | "N" {
  if (seed % 17 === 0) return "SSR";
  if (seed % 7 === 0) return "SR";
  if (seed % 3 === 0) return "R";
  return "N";
}

export function createComment(
  input: Omit<
    Comment,
    "id" | "createdAt" | "author" | "avatar" | "status" | "isMine"
  >,
): Comment {
  return {
    ...input,
    id: `comment-${Date.now()}`,
    author: "林间记录者",
    avatar: "林",
    createdAt: "刚刚",
    status: moderateComment(input.text, Boolean(input.image)),
    isMine: true,
  };
}
